import { render, staticRenderFns } from "./TrapezoidViz.vue?vue&type=template&id=2dd86f8f&scoped=true"
import script from "./TrapezoidViz.vue?vue&type=script&lang=js"
export * from "./TrapezoidViz.vue?vue&type=script&lang=js"
import style0 from "./TrapezoidViz.vue?vue&type=style&index=0&id=2dd86f8f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd86f8f",
  null
  
)

export default component.exports